import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from '@Store/store'

interface RemoteAppState {
  appUrl?: string
  accessToken?: string
  refreshToken?: string
  panelVersion: number
}

const initialState: RemoteAppState = {
  appUrl: undefined,
  accessToken: undefined,
  refreshToken: undefined,
  panelVersion: 0,
}

const remoteAppSlice = createSlice({
  name: 'remoteApp',
  initialState,
  reducers: {
    setAppUrl: (state, action: PayloadAction<string>) => {
      state.appUrl = action.payload
    },
    setAppTokens: (
      state,
      action: PayloadAction<{ access_token: string; refresh_token: string }>,
    ) => {
      state.accessToken = action.payload.access_token
      state.refreshToken = action.payload.refresh_token
    },
    switchPanelTokens: (
      state,
      action: PayloadAction<{ access_token: string; refresh_token: string }>,
    ) => {
      state.accessToken = action.payload.access_token
      state.refreshToken = action.payload.refresh_token
      state.panelVersion += 1
    },
  },
})
const { actions, reducer } = remoteAppSlice
const { setAppUrl, setAppTokens, switchPanelTokens } = actions

const useRemoteAppState = (): RemoteAppState =>
  useSelector((state) => state.remoteApp)

const useRemoteAppActions = () => {
  const dispatch = useDispatch()

  return {
    setAppUrl: (payload: string) => dispatch(setAppUrl(payload)),
    setAppTokens: (payload: { access_token: string; refresh_token: string }) =>
      dispatch(setAppTokens(payload)),
    switchPanelTokens: (payload: {
      access_token: string
      refresh_token: string
    }) => dispatch(switchPanelTokens(payload)),
    clearAppTokens: () =>
      dispatch(setAppTokens({ access_token: '', refresh_token: '' })),
  }
}

export default reducer
export {
  useRemoteAppActions,
  useRemoteAppState,
  setAppUrl,
  setAppTokens,
  switchPanelTokens,
}
